import React from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

import Funds from '../Funds';
import InvestmentsBanner from '../InvestmentsBanner';
import InvestmentDonut from '../InvestmentsBanner/InvestmentDonut/InvestmentDonut';
import SliderPL from '../InvestmentsBanner/SliderPL';
import InvestmentsFooter from '../InvestmentsFooter';

import PerformanceChart from './PerformanceChart';
import TradingSummary from './TradingSummary';

const InvestmentsPerformance = () => {
  const { isMobile } = useResponsive();
  return (
    <Box direction="column">
      <InvestmentsBanner isPerformanceMode>
        <SliderPL isUnwrappedMode />
        <Box margin={isMobile ? {} : { left: 's' }}>
          <InvestmentDonut isPerformanceMode isExpandedMode={!isMobile} />
        </Box>
      </InvestmentsBanner>

      <Box
        direction={isMobile ? 'column' : 'row'}
        margin={{ top: 'spacing24' }}
        pad="spacing24"
        background="border1"
        round="moduleRound"
      >
        <Box fill margin={{ right: 'spacing24' }}>
          <PerformanceChart />
        </Box>
        <Box margin={isMobile ? { top: 'spacing12' } : {}} width={isMobile ? {} : { min: '270px' }}>
          <TradingSummary />
        </Box>
      </Box>

      <Box
        direction="row"
        margin={isMobile ? { top: 'spacing16' } : { top: 'spacing24' }}
        pad={
          isMobile
            ? {
                vertical: 'spacing12',
                horizontal: 'spacing16',
              }
            : 'spacing24'
        }
        background="border1"
        round="moduleRound"
      >
        <Funds />
      </Box>

      <InvestmentsFooter />
    </Box>
  );
};

export default InvestmentsPerformance;
